import Axios from 'axios'

const documentManagement = {
  axios () {
    let AxiosInstance = Axios
    AxiosInstance.defaults.baseURL = process.env.BACKEND_URL
    return AxiosInstance
  },
  getAllDocuments () {
    return this.axios().get('/exam/document/all')
  },
  sendDocument (document) {
    let formData = new FormData()

    formData.append('name', document.file)
    return this.axios().post('/exam/document/upload', formData, {
      params: {
        'user-file-name': document.name
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  updateDocument (document) {
    let formData = new FormData()

    formData.append('name', document.file)
    return this.axios().put('/exam/document/upload', formData, {
      params: {
        'file-id': document.id
      },
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
  },

  downloadDocumentUploaded (fileId) {
    return this.axios().get('/exam/document/download-document/' + fileId, {
      responseType: 'arraybuffer'
    })
  },

  updateDocumentName (document) {
    return this.axios().put('/exam/document/rename-doc-file', null, {
      params: {
        'file-id': document.fileId,
        'new-file-name': document.fileName
      }
    })
  },
  deleteDocument (fileId) {
    return this.axios().delete('/exam/document/' + fileId)
  },
  downloadDocumentByUuid (uuid) {
    return this.axios().get('/exam/document/download/template/' + uuid, {
      responseType: 'arraybuffer'
    })
  },
  getAllExamsAndDocumentsLinked () {
    return this.axios().get('/exam/document/document-exam/all')
  },
  createLinkOverDocumentAndExam (link) {
    return this.axios().post('/exam/document/document-exam', null, {
      params: {
        'exam-id': link.examId,
        'file-id': link.fileId
      }
    })
  },
  deleteLinkOverDocumentAndExam (linkId) {
    return this.axios().delete('/exam/document/document-exam/' + linkId)
  }
}

export default documentManagement
